<template>
    <q-page padding>
        <q-tabs v-model="tab" color="white" text-color="primary" underline-color="primary" class="shadow-1 bg-white" align="justify">
            <q-tab slot="title" name="faq" :label="$t(title_faq)" icon="fal fa-question-circle" />

            <q-tab-pane name="faq" class="q-px-md q-pb-xl q-mt-md">
                <div class="row gutter-sm">
                    <div :class="filterClass">
                        <q-list>
                            <q-collapsible class="filter" icon="fal fa-filter" :label="$t('filter')" :opened="!$q.platform.is.mobile ? true : false">
                                <q-list no-border>
                                    <q-item>
                                        <q-item-main>
                                            <q-search v-model="search" :placeholder="$t('search')" icon="fal fa-search" :debounce="500" />
                                        </q-item-main>
                                    </q-item>

                                    <q-item>
                                        <q-item-main>
                                            <p class="caption">{{ $t('category') }}</p>
                                            <q-btn-toggle
                                                class="full-width q-mb-sm progress"
                                                v-model="category"
                                                toggle-color="primary"
                                                :options="[
                                                    {label: $t('all'), value: 'all'}
                                                ]"
                                            />
                                            <q-btn-toggle
                                                v-for="(cat, index) in categories"
                                                :key="index"
                                                class="full-width q-mb-sm progress"
                                                v-model="category"
                                                toggle-color="primary"
                                                :options="[
                                                    {label: cat.title, value: cat.id}
                                                ]"
                                            />
                                        </q-item-main>
                                    </q-item>
                                </q-list>
                            </q-collapsible>
                        </q-list>
                    </div>

                    <div :class="contentClass">
                        <div class="row gutter-md">
                            <div class="col-12">
                                <q-alert class="cursor-pointer" color="info" icon="cloud" @click.native="$router.push({ name: 'help' })">
                                    {{ $t('did_not_find_an_answer_send_your_question') }} {{ $t('here') }}
                                </q-alert>
                            </div>

                            <div class="col-12">
                                <q-list separator sparse>
                                    <q-collapsible v-for="(question, index) in filteredQuestions" :key="index" :label="question.question" :sublabel="getCategory(question.faq_category)" group="faq" :opened="collapsed === question.id ? true : false">
                                        <blockquote>
                                            {{ question.faq_question_answer }}
                                        </blockquote>
                                    </q-collapsible>

                                    <q-collapsible v-if="filteredQuestions.length === 0" :label="$t('no_questions_found')" group="faq" disable>
                                    </q-collapsible>
                                </q-list>
                            </div>
                        </div>
                    </div>
                </div>
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    i18nOptions: { namespaces: [ "custom", 'common', 'faq'] },

    data() {
        return {
            categories: [],
            questions: [],
            tab: 'faq',
            category: 'all',
            search: '',
            collapsed: ''
        }
    },

    computed: {
        ...mapGetters({
			access_token: 'common/access_token',
			clients: 'params/clients',
			id_user_client_selected: 'common/id_user_client_selected'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

		title_faq(){
			if (this.id_user_client_selected) {
				let obj = this.clients.find((obj) => { return obj.id === this.id_user_client_selected })
				if (obj) {
					return obj.title_faq == '' ? 'faq' : obj.title_faq
				}
			}
        },

        filteredQuestions() {
            let filtered = []
            filtered = Object.assign(this.questions, [])

            if (this.search) {
                filtered = filtered.filter((question) => {
                    return question.question.toUpperCase().includes(this.search.toUpperCase()) || question.faq_question_answer.toUpperCase().includes(this.search.toUpperCase())
                })
            }

            if (this.category != 'all') {
                filtered = filtered.filter((question) => {
                    return question.faq_category === this.category
                })
            }

            return filtered
        },

        filterClass() {
            if (this.$q.platform.is.ipad) return 'col-12'
            else return 'col-xs-12 col-sm-3'
        },

        contentClass() {
            if (this.$q.platform.is.ipad) return 'col-12'
            else return 'col-xs-12 col-sm-9'
        }
    },

    methods: {
        fetchData() {
            this.$q.loading.show()

            this.$axios.all([this.fetchQuestions(), this.fetchCategories()])
            .then(this.$axios.spread((questions, categories) => {
                this.questions = []
                this.categories = []

                questions.data.forEach(question => {
                    if (!this.collapsed) this.collapsed = question.id
                    this.questions.push(question)
                })

                categories.data.forEach(category => {
                    this.categories.push(category)
                })

                this.$q.loading.hide()
            }))
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        fetchQuestions() {
            return this.$axios.get('/etraining_faq/faq/', this.getHeader)
        },

        fetchCategories() {
            return this.$axios.get('/etraining_faq/categories/', this.getHeader)
        },

        getCategory(id) {
            let obj = this.categories.find((obj) => { return obj.id === id })
            if (obj) return obj.title
            else return ''
        }
    },

    created() {
        this.fetchData()
    }
}
</script>

<style lang="stylus" scoped>
a
    text-decoration none
    color white
</style>
